// src/pages/GDPR.tsx
const GDPR = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="page-hero">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1508345228704-935cc84bf5e2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')" }}
        ></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="hero-content max-w-2xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">GDPR Politika</h1>
            <p className="text-xl">Varovanje vaših osebnih podatkov</p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-xl shadow-xl p-8 border border-gray-100 card-glow">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl font-bold mb-6">Politika zasebnosti in varovanja osebnih podatkov</h2>

              <div className="space-y-6 text-gray-700">
                <p>
                  Avtoservis Vodnik, Bukovec 10A, 2314 Zgornja Polskava (v nadaljevanju: "mi", "nas", "naše") spoštujemo vašo zasebnost in se zavezujemo k varovanju vaših osebnih podatkov. Ta politika zasebnosti pojasnjuje, kako zbiramo, uporabljamo, razkrivamo, prenašamo in hranimo vaše podatke.
                </p>

                <h3 className="text-xl font-semibold mt-8 mb-3">1. Podatki, ki jih zbiramo</h3>
                <p>
                  Zbiramo podatke, ki nam jih posredujete preko kontaktnih obrazcev, e-pošte, telefona ali osebno v naših prostorih:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Kontaktni podatki (ime, e-naslov, telefonska številka)</li>
                  <li>Podatki o vozilu (znamka, model, letnik, registrska številka)</li>
                  <li>Podatki o storitvah, ki jih želite opraviti</li>
                </ul>

                <h3 className="text-xl font-semibold mt-8 mb-3">2. Kako uporabljamo vaše podatke</h3>
                <p>
                  Vaše osebne podatke uporabljamo za naslednje namene:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Zagotavljanje zahtevanih storitev</li>
                  <li>Komuniciranje z vami glede naših storitev</li>
                  <li>Obveščanje o statusu popravila/servisa vašega vozila</li>
                  <li>Izboljšanje naših storitev</li>
                  <li>Izpolnjevanje zakonskih obveznosti</li>
                </ul>

                <h3 className="text-xl font-semibold mt-8 mb-3">3. Pravna podlaga za obdelavo</h3>
                <p>
                  Vaše osebne podatke obdelujemo na podlagi ene ali več naslednjih pravnih podlag:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Vaše privolitve</li>
                  <li>Potrebe za izvajanje pogodbe z vami</li>
                  <li>Izpolnjevanja naših zakonskih obveznosti</li>
                  <li>Naših legitimnih interesov, ki ne prevladajo nad vašimi interesi ali temeljnimi pravicami in svoboščinami</li>
                </ul>

                <h3 className="text-xl font-semibold mt-8 mb-3">4. Vaše pravice</h3>
                <p>
                  V skladu z GDPR imate naslednje pravice v zvezi z vašimi osebnimi podatki:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Pravica do dostopa do vaših osebnih podatkov</li>
                  <li>Pravica do popravka netočnih podatkov</li>
                  <li>Pravica do izbrisa ("pravica do pozabe")</li>
                  <li>Pravica do omejitve obdelave</li>
                  <li>Pravica do prenosljivosti podatkov</li>
                  <li>Pravica do ugovora</li>
                  <li>Pravica do vložitve pritožbe pri nadzornem organu</li>
                </ul>

                <h3 className="text-xl font-semibold mt-8 mb-3">5. Kontaktne informacije</h3>
                <p>
                  Za vsa vprašanja glede te politike zasebnosti ali naših praks glede osebnih podatkov, nas prosimo kontaktirajte:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg my-4">
                  <p><strong>Avtoservis Vodnik</strong></p>
                  <p>Bukovec 10A, 2314 Zgornja Polskava</p>
                  <p>Email: milan_acko@t-2.net</p>
                  <p>Telefon: 041 273 738</p>
                </div>

                <p>
                  Zadnja posodobitev: {new Date().toLocaleDateString()}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GDPR;